import React, { useContext } from "react";
import { Modal, Button } from "antd";
import ICFail from "./../../acsset/ic-fail.png";
import { AuthContext } from "./../index";

const Fail = ({ handleCancel, open, uploadAllImages }) => {
  const { UploadOrder, messErrApi } = useContext(AuthContext);

  const css = {
    divButton: {
      display: "flex",
      justifyContent: "space-around",
      marginTop: "15px",
      alignItems: "center",
      fontSize: 15
    },
    button: {
      width: "100%",
      height: 40,
      borderRadius: 8,
      background: "#009B4B",
      borderColor: "#009B4B",
      color: "#FFF",
      fontWeight: 600
    },
  };
  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        style={{
          margin: 0,
          padding: 0,
          maxWidth: '325px'
        }}
        className="modal-custom"
        centered={true}
        footer={false}
        open={true}
        // onCancel={props.handleCancel}
        closable={false}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <div style={{ textAlign: "center" }}>
          <img src={ICFail} style={{ width: "60px" }} />
          <div
            style={{
              fontSize: 18,
              marginTop: 10,
              fontWeight: 600,
              color: "#343A40",
            }}
          >
            Bạn đã chụp hình xe thất bại
          </div>
          <div style={{ fontSize: 16, marginTop: 10, color: "#343A40", fontWeight: 500 }}>
            {messErrApi}
          </div>
          <div style={css.divButton}>
            <Button
              onClick={() => {
                uploadAllImages();
                handleCancel();
              }}
              style={css.button}>
              <div style={{fontSize: 15}}>Gửi lại</div>
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Fail;
